<script>
import { genderFilter, taiwanCitys, districtsFilter, findDistrictZip, taxTypeMap, carrierTypeMap } from '@utils/filter-value-to-text'
import cloneDeep from 'lodash/cloneDeep'
import lazyLoadComponent from '@router/lazyload-component'


const extraInfoPhone ={
  // type:'phone',
  phoneCode:'+886',
  phoneNumber:''
}

const extraInfoEmergency ={
  // type:'emergency',
  phoneCode:'+886',
  phoneNumber:'',
  fullName:'',
  gender:'male'
}
const defaultComment = {
    id: '',
    content: '',
}
export default {
  components: {
    InvoiceForm: () => lazyLoadComponent(import('@components/InvoiceForm')),
    CountryCodePicker: () => lazyLoadComponent(import('@components/CountryCodePicker')),
    MemberInfoCommentList: () => lazyLoadComponent(import('@components/MemberInfoCommentList')),
  },
  filters: { genderFilter },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      default: cloneDeep(this.value) ,
      editDetailEnabled: false,
      tryingList: false,
      form: cloneDeep(defaultComment) ,
      rules: {
        content: {
          required: true, message: '請填寫備註', trigger: 'blur'
        }
      },
      isUpdteEdit: false
    }
  },
  computed: {
    submitData: {
      get() {
        return this.value
      },
      set(value) {
        this.$set(value,'content',this.content)
        this.$emit('input', value);
      }
    },
  },
  watch: {

  },
  created() {

  },
  mounted() {
  },
  methods: {
    enableAddNotice() {
      const data = {
        isEditEnabled: true,
        type: 'note'
      }
      this.editDetailEnabled = true
      this.$emit('isEditDeatilEnabled', data)
    },
    editCommemt(item = {}) {
      this.editDetailEnabled = true
      this.isUpdteEdit = true
      this.form = item
    },
    async onClickRemove(id) {
      this.tryingList = true
      try {
        await this.$store.dispatch('comment/removeComment', { ids: [id] })
        this.$message({ message:'刪除成功', type: 'success' })
        this.updateValue()
      } finally {
        this.tryingList = false
      }
    },
    updateValue() {
      this.$emit('update')
    },
    async onClickSave(){
      const { id, memberId, content } = this.form
      this.tryingList = true
      await this.$store.dispatch('comment/store', {
        uuid: id, 
        memberId, 
        content,
        type: 'member_private'
      }).finally(()=> {
        this.updateValue()
        this.tryingList = false
        this.editDetailEnabled = false
        this.isUpdteEdit = false
        this.form = cloneDeep(defaultComment)
      })
    },
    onClickCancel() {
      this.editDetailEnabled = false
      this.isUpdteEdit = false
      this.form = cloneDeep(defaultComment)
    }
  },
}
</script>

<template>
  <div>
    <BasePageHeader  
    >
      <template v-slot:title>
        客戶備註
        <span class="fs-2sm text-danger fw-regular">(客戶無法查看)</span>
      </template>
      <template v-slot:right>
        <el-button
          v-if="!editDetailEnabled" 
          type="primary"
          class="is-round isStyleBase"
          @click="enableAddNotice"
        >
          <BaseIcon name="plus"/> 新增備註
        </el-button>
      </template>
    </BasePageHeader>
    <div class="isStylePageContent">
      <MemberInfoCommentList
        v-if="!editDetailEnabled"
        v-loading="tryingList" 
        
        :default-value="submitData.memberPrivateComments.items"
        @edit="editCommemt"
        @remove="onClickRemove"
      />
      <!-- <template v-if="isCanAdd"> -->
        <!-- <el-button 
          v-if="!isUpdteEdit && isOrder"
          type="primary"
          class="w-100 is-round mt-5"
          @click="editCommemt"
        >
          新增備註
        </el-button> -->
        <template v-else>
          <p class="fs-base mb-3 fw-medium text-text">
            {{ isUpdteEdit ? '編輯備註' : '新增備註'}} 
            <span class="fs-2sm text-text-light fw-regular">(客戶無法查看)</span>
          </p>
          <el-form ref="form" :model="form" :rules="rules" class="mb-5">
            <el-form-item prop="content">
              <el-input 
                v-model="form.content" 
                type="textarea" 
                class="bg-white is-border is-round"
                :autosize="{ minRows: 5 }"
              />
              <div v-if="isUpdteEdit" class="d-flex mt-3">
                <el-button 
                  class="is-round w-100"
                  @click="onClickCancel"
                >
                  <BaseIcon name="times" class="fs-xl align-text-top"/>
                  取消
                </el-button>
                <el-button 
                  type="primary"
                  class="ml-2  is-round  w-100"
                  @click="onClickSave"
                >
                  <BaseIcon name="check" class="fs-xl align-text-top"/>
                  儲存
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </template>
      <!-- </template> -->
    </div>
  </div>
</template>
<style lang="scss" module>
.detail li {
  line-height: 40px;
}
.label-tag {
  :global {
    .el-tag {
      border-color: #808080;
      border-radius: 3px;
      height: 25px;
      line-height: 25px;
      color: #808080;
      margin-bottom: 10px;
    }
    .el-tag + .el-tag {
      margin-left: 10px;
    }
  }
}
.footer {
  display: flex;
  :global {
    button {
      flex: 1 0 auto;
    }
  }
}
.detail-form {
  width:550px;

  @include max-sm {
    width: 100%;
  }
  :global {
    .el-input-group__append,
    .el-input-group__prepend {
      border: 1px solid #dcdfe6 !important;
    }
  }
}
</style>
